import {gql} from "@apollo/client"
export const GET_DASH_INFO = gql`
  query GetDashInfo {
    GetDashInfo
  }
`
